import { store } from "@/store/index";
import { toGetSearch } from "@/utils/stringFun";
import { Loading } from "element-ui";
import urlencode from "urlencode";
export default {
  data: function data() {
    return {
      obj: {}
    };
  },
  methods: {
    exportCsv: function exportCsv(e, m, n) {
      var _this = this;
      var loadingInstance = Loading.service({
        fullscreen: true
      });
      var token = urlencode.encode(store.getters["user/token"], "GBK");
      if (n) {
        this.obj = {
          token: token,
          searchList: m
        };
      } else {
        this.obj = {
          token: token,
          page: this.page,
          pageSize: this.pageSize,
          searchList: m
        };
      }
      var res = toGetSearch(this.obj);
      var url = e + res;
      window.open(url, "_blank");
      setTimeout(function () {
        _this.$nextTick(function () {
          loadingInstance.close();
        });
      }, 1000);
    }
  }
};